import { render, staticRenderFns } from "./SnapshotCreateInspectorModal.vue?vue&type=template&id=0b0c7ef6&scoped=true&"
import script from "./SnapshotCreateInspectorModal.vue?vue&type=script&lang=ts&"
export * from "./SnapshotCreateInspectorModal.vue?vue&type=script&lang=ts&"
import style0 from "./SnapshotCreateInspectorModal.vue?vue&type=style&index=0&id=0b0c7ef6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0c7ef6",
  null
  
)

export default component.exports